import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '@environments/environment';
import { Card, CardSet, CardType, MarketPlace } from '@models/card.model';

@Pipe({
  name: 'imgMarketPlace',
  standalone: false
})
export class ImgMarketPlacePipe implements PipeTransform {

  transform(market: MarketPlace){
    return `${environment.imgUrl}/skin/markets/${market.logo}`;
  }

}

@Pipe({
  name: 'imgCardType',
  standalone: false
})
export class ImgCardType implements PipeTransform {

  transform(type: CardType){
    return `${environment.imgUrl}/skin/types/${type.img}`;
  }

}

@Pipe({
  name: 'imgSymbol',
  standalone: false
})
export class ImgSymbol implements PipeTransform {

  transform(cardSet: CardSet){
    let path: string=null;
    if(cardSet.symbol)
      path=`${environment.imgUrl}/set/symbol/${cardSet.symbol}.png`;

    return path;
  }

}


